import { IconButton, Tooltip } from "@mui/material";
import Rainbow from "@mui/icons-material/Looks";
import { TOOLTIP_PROPS } from "./internalToolsUtils";

export function VisitCustomerPortalLink({ ckey }: { ckey: string }) {
  return (
    <Tooltip title={`↗ Portal Admin`} {...TOOLTIP_PROPS}>
      <IconButton
        size="small"
        onClick={() => {
          window.open(`https://portal.raven.ai/${ckey}/home`, "_blank");
        }}
      >
        <Rainbow />
      </IconButton>
    </Tooltip>
  );
}
